import React, { useCallback, useMemo } from "react";
import StatusBadge from "../../common/Badge/StatusBadge";
import { ALL_STATUSES } from "../../../constants/statuses";

const StatusTagSelect = ({ data = [], onChange, locked = false }) => {
  const [showFilter, setShowFilter] = React.useState(false);

  const handleStatusToggle = useCallback(
    (status) => {
      if (!onChange) return;

      const newStatuses = data.includes(status)
        ? data.filter((s) => s !== status)
        : [...data, status];

      onChange(newStatuses);
    },
    [data, onChange]
  );

  const handleToggleFilter = useCallback(() => {
    if (!locked) {
      setShowFilter((prev) => !prev);
    }
  }, [locked]);

  const handleClearAll = useCallback(() => {
    if (onChange) {
      onChange([]);
    }
  }, [onChange]);

  const placeholderText = useMemo(() => {
    if (data.length === 0) {
      return "Kliknij, aby wybrać statusy do filtrowania";
    }
    return `Wybrano: ${data.length} status(ów)`;
  }, [data.length]);

  return (
    <div className="status-tag-select">
      <div
        className="d-flex flex-wrap form-control text-black-50"
        onClick={handleToggleFilter}
        role="button"
        tabIndex={0}
      >
        {data.length === 0 ? (
          <span>{placeholderText}</span>
        ) : (
          data.map((status) => (
            <div key={status} className="p-0-5">
              <StatusBadge text={status} colorMode="Operator" />
            </div>
          ))
        )}
      </div>

      {showFilter && (
        <div className="d-flex flex-column border rounded-bottom-3 p-1">
          <div className="d-flex flex-row align-items-center mb-2">
            <label className="form-label mb-0">
              Wybierz statusy do filtrowania
            </label>
            <button
              type="button"
              className="btn btn-sm btn-link ms-auto"
              onClick={() => setShowFilter(false)}
              title="Ukryj"
            >
              ↑ Ukryj
            </button>
          </div>

          <div className="d-flex flex-wrap mb-2">
            {ALL_STATUSES.map((status) => (
              <div
                key={status}
                className="d-flex flex-row border rounded-3 p-0-5 ms-1 mb-1"
              >
                <input
                  type="checkbox"
                  className="form-check-input small me-1 align-self-center"
                  id={`status-${status}`}
                  checked={data.includes(status)}
                  onChange={() => handleStatusToggle(status)}
                  aria-label={`Select ${status}`}
                />
                <label
                  htmlFor={`status-${status}`}
                  style={{ cursor: "pointer", marginBottom: 0 }}
                >
                  <StatusBadge text={status} colorMode="Operator" />
                </label>
              </div>
            ))}
          </div>

          <div className="d-flex flex-row gap-2">
            <button
              type="button"
              className="btn btn-primary w7 ms-auto h2"
              onClick={() => setShowFilter(false)}
            >
              Zamknij
            </button>
            <button
              type="button"
              className="btn btn-outline-primary w7 h2"
              onClick={handleClearAll}
            >
              Wyczyść
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusTagSelect;
